import Notifications from 'service/Notifications';
import AuthWebService from 'service/web/AuthWebService';
import EventWebService from 'service/web/EventWebService';
import F from 'utils/F';
import {userStore} from "stores";

export default class ErrorHandler {


    static _handle = async (title, message, isWarning, error, showNotification, reportIssues) => {
        if (showNotification) {
            if (isWarning) {
                Notifications.warn(message, title);
            } else {
                Notifications.error(message, title);
            }
        }
        const category = isWarning ? 'WARN' : 'ERROR';
        if (reportIssues) {
            if (error) {
                await EventWebService.event(category, null, null,
                    JSON.stringify(error, Object.getOwnPropertyNames(error)));
            } else {
                await EventWebService.event(category, null, null, message);
            }
        }
    };

    static handleGlobalError = (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        ErrorHandler.defaultErrorHandler(event.error, true, true);
    };

    static handleGlobalRejection = (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        // HttpService already showed a notification before re-throwing, so
        // only show a fallback notification for truly unexpected rejections
        // (those without a response object, i.e. not from HttpService).
        const alreadyHandled = event.reason && event.reason.response;
        ErrorHandler.defaultErrorHandler(event.reason, !alreadyHandled, !alreadyHandled);
    };

    static defaultErrorHandler = async (error, showNotification, reportIssues) => {
        if (!error) return false;
        let isWarning = true;
        let title = 'Sorry';
        let message = '';
        let canRetry = false;
        let then = () => {};

        if (error.response) {
            const status = error.response.status;
            if (status === 401 || status === 403) {
                title = 'Please login';
                message = 'Session expired';
                then = async () => {
                    F.sleep(3000).then(() => { AuthWebService.logOut(); window.location.href = '/login'; });
                };
            }
            if (status === 409) {
                canRetry = true;
                showNotification = false;
                reportIssues = false;
            }
            if (status === 429) {
                title = 'Sorry, we are experiencing a large number of requests';
                message = 'We\'ll be back shortly';
                canRetry = true;
            }
            if (status >= 500) {
                title = 'Something went wrong';
                message = 'We\'re having trouble completing your request. Please try again.';
                isWarning = false;
            }
            if (error.response.data?.message) {
                message = error.response.data.message;
            }
        }

        if (error.message) {
            if (error.message.toLowerCase().includes('network')) {
                title = 'Sorry, we are having issues contacting the server';
                message = 'Please check you are connected to the Internet. Retrying...';
                isWarning = false;
                canRetry = true;
                userStore.setNetworkStatus(false);
            }
            if (error.message.includes('timeout') && error.message.includes('exceeded')) {
                title = 'Sorry, we are having trouble reaching our servers';
                message = 'We\'ll be back shortly';
                canRetry = true;
            }
            if (message === '') {
                message = 'An unexpected error occurred. Please try again.';
            }
        }

        if (message === '') {
            message = 'An unexpected error occurred. Please try again.';
        }

        await ErrorHandler._handle(title, message, isWarning, error, showNotification, reportIssues);
        await then();
        return canRetry;
    };
}